<template>
  <div>
    <div class="d-flex col-12 justify-content-end p-0">
      <div class="col-lg-5 col-5 px-2 pt-2 transaction">
        <v-select
          v-model="filters.date"
          :reduce="(draw) => draw.data"
          label="label"
          :options="dateOptions"
        ></v-select>
      </div>
      <div class="pt-1">
        <button
          type="button"
          class="btn btn-primary mt-4 ml-1"
          style="flex-shrink: 0"
          @click="
            filters.page = 1;
          fetchUserDeposits();
          "
        >
          {{ $t("transaction.all") }}
          {{ $t("transaction.search") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex justify-content-center mx-auto my-5"
      v-if="isDepositsFetching"
    >
      <Loading
        color="#000000"
        size="24"
        class="px-4 py-0"
      />
      <span> Loading ... </span>
    </div>
    <div
      class="mx-auto my-5"
      v-else-if="deposits.length === 0"
    >
      <h3 class="text-center">No Deposits Found</h3>
    </div>
    <table
      class="table align-items-center table-custom pt-3"
      v-else
    >
      <thead style="background: #282a31; border: none">
        <tr>
          <th>{{ $t("voucher.total_amount") }}</th>
          <th>{{ $t("transaction.status") }}</th>
          <th>form တင်သည့် အချိန်</th>
        </tr>
      </thead>
      <tbody class="list">
        <tr
          v-for="(data, index) in deposits"
          :key="index"
        >
          <td>{{ data.amount }}</td>
          <td>
            <span
              class="badge"
              :class="{
                'badge-success': data.status === 'confirm',
                'badge-warning': data.status === 'pending',
                'badge-danger': data.status === 'fail',
              }"
            >
              {{ getStatusLabel(data.status) }}
            </span>
          </td>
          <td>{{ data.date }}</td>
        </tr>
      </tbody>
    </table>
    <p class="font-weight-bold">Total Deposits - {{ depositData?.total }}</p>

    <Pagination
      align="center"
      :data="depositData"
      @pagination-change-page="fetchUserDeposits"
      :limit="3"
    />
  </div>
</template>
<script>
import Pagination from "laravel-vue-pagination";
import { DateTime } from "luxon";
import { Loading } from "vant";

export default {
  components: {
    Pagination,
    Loading
  },
  data() {
    return {
      deposits: [],
      depositData: {},
      isDepositsFetching: true,
      filters: {
        page: 1,
        perPage: 5,
        date: null,
      },
      dateOptions: [],

    };
  },
  methods: {
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format("l");
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString("en-US", {
        timeZone: targetTimeZone,
      });
      return moment(adjustedDrawDate).format("lll");
    },
    async fetchUserDeposits(page = 1) {
      this.isDepositsFetching = true;
      try {
        this.filters.page = page;
        const response = await axios.get(
          `/users/${this.$store.state.authUser.id}/deposits`,
          {
            params: this.filters,
          }
        );
        this.depositData = response.data;
        this.deposits = response.data.data;
      } catch (error) {
        this.$toast.fail("Failed!");
      } finally {
        this.isDepositsFetching = false;
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case "confirm":
          return "အတည်ပြုပြီး";
        case "pending":
          return "လျှောက်ထားဆဲ";
        case "fail":
          return "အငြင်းခံရသည်";
        default:
          return status;
      }
    },
  },
  mounted() {
    this.setOneMonth();
    this.filters.date = moment(new Date()).format("l");
    this.fetchUserDeposits();
  },
};
</script>

<style scoped>
tr th {
  color: #fff;
}

tr td {
  border-color: rgb(183, 170, 170);
  color: rgb(183, 170, 170) !important;
  font-weight: 700;
}

.table-custom {
  display: block;
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.page-item.active .page-link {
  color: white !important;
}
</style>
